import { useState } from 'react';
import { post } from '../../api-services/fetch';
import { useAppContext } from '../../context/app/AppProvider';
import { APP_MODE, SELECTED_BUSINESS } from '../../context/app/appTypes';
import { encodeToken, decodeToken } from '../../utilities/auth';
import notification from '../../utilities/notification';
import useOnboardingStore from '../../context/onboarding/onboardingStore';
import { getBusinessTier } from '../../utilities/businessTier';

export const useEnvironmentSwitch = () => {
  const { appContext, setAppContext } = useAppContext();
  const { merchantDetails } = useOnboardingStore();
  const [isSwitching, setIsSwitching] = useState(false);
  const [error, setError] = useState(null);

  const switchToTest = async () => {
    setIsSwitching(true);
    setError(null);

    const res = await post({
      endpoint: 'switchEnvironment',
      body: { environment: 'test' },
      showUnauthorizedModalOn401: true
    });

    setIsSwitching(false);

    const isSuccess =
      res?.status >= 200 && res?.status < 300 && res?.data?.status;

    if (isSuccess) {
      const testBusiness = res.data.data;

      if (appContext.business?.id) {
        encodeToken('liveBusiness', appContext.business);
      }

      encodeToken('sb', testBusiness);
      setAppContext({ type: SELECTED_BUSINESS, payload: testBusiness });
      setAppContext({ type: APP_MODE, payload: 'test' });

      return true;
    }

    const message =
      res?.data?.message || 'Could not switch to test mode. Please try again.';
    setError(message);
    notification({ message, type: 'danger' });
    return false;
  };

const switchToLive = () => {
    const liveBusiness =
        decodeToken('liveBusiness', null, false) || {};

    encodeToken('sb', liveBusiness);

    setAppContext({
        type: SELECTED_BUSINESS,
        payload: liveBusiness
    });

    setAppContext({
        type: APP_MODE,
        payload: 'live'
    });

    return true;
};
  const switchTo = async (targetMode) => {
    if (targetMode === appContext.mode || isSwitching) return false;
    return targetMode === 'test' ? switchToTest() : switchToLive();
  };

  const merchant = decodeToken('da', null, false);

  return {
    mode: appContext.mode,
    isSwitching,
    error,
    businessTier: getBusinessTier(merchantDetails),
    switchTo,
    switchToTest,
    merchant,
    switchToLive
  };
};